import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
    },
    theme: {
        light: true,
        themes: {

            light: {
                primary: '#123481',
                secondary: '#03CCCB', //rgba(21, 90, 152, 0.4)
                accent: '#2E8CCF',
                // error: colors.red.accent3,
            },
            /* dark: {
                 primary: '#47d1fc',
                 accent: '#47d1fc',

             },*/
        },
    },
});